import React, { lazy, Suspense } from 'react';
import { CompatRoute } from 'react-router-dom-v5-compat';
import { useFlags } from 'launchdarkly-react-client-sdk';

import { AuthorizedRoutes } from './authorized-routes';
import NonAuthRoutes from './non-authorized-routes';
import { PageLoader } from '../common-components/loading/PageLoader';
import { PortalUser } from '../stores/rematch/models/auth-store';
import { useIdentifyLDUser } from '../integrations/launch-darkly';

const NotFound = lazy(() => import('../views/other/not-found').then((m) => ({ default: m.NotFound })));

function NotFoundRoutes() {
  const { en53 } = useFlags();

  return (
    <Suspense fallback={<PageLoader />}>
      {en53 && (
        <CompatRoute path='*'>
          <NotFound />
        </CompatRoute>
      )}
    </Suspense>
  );
}

type RoutesProps = {
  portalUser?: PortalUser | null;
  isAuthenticated: boolean;
};

function Routes({ portalUser, isAuthenticated }: RoutesProps): JSX.Element {
  void useIdentifyLDUser({ portalUser });

  return (
    <>
      <AuthorizedRoutes />
      <NonAuthRoutes isAuthenticated={isAuthenticated} />
      <NotFoundRoutes />
    </>
  );
}

export default Routes;
